var _rect, _rect2, _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFutureBgSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1437,
    height: 716,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 63,
    width: 5,
    height: 31,
    rx: 2.5,
    transform: "rotate(-180 138 63)",
    fill: "#F9DB6D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 50,
    width: 5,
    height: 31,
    rx: 2.5,
    transform: "rotate(-90 120 50)",
    fill: "#F9DB6D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 546.5,
    r: 15,
    transform: "rotate(-180 117.5 546.5)",
    stroke: "#387",
    strokeOpacity: 0.07,
    strokeWidth: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.5,
    cy: 491.5,
    r: 15,
    transform: "rotate(-180 704.5 491.5)",
    stroke: "#387",
    strokeOpacity: 0.07,
    strokeWidth: 7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 636,
    cy: 103,
    r: 19.5,
    transform: "rotate(-180 636 103)",
    stroke: "#387",
    strokeOpacity: 0.07,
    strokeWidth: 7
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQzNyIgaGVpZ2h0PSI3MTYiIHZpZXdCb3g9IjAgMCAxNDM3IDcxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTM4IiB5PSI2MyIgd2lkdGg9IjUiIGhlaWdodD0iMzEiIHJ4PSIyLjUiIHRyYW5zZm9ybT0icm90YXRlKC0xODAgMTM4IDYzKSIgZmlsbD0iI0Y5REI2RCIvPgo8cmVjdCB4PSIxMjAiIHk9IjUwIiB3aWR0aD0iNSIgaGVpZ2h0PSIzMSIgcng9IjIuNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDEyMCA1MCkiIGZpbGw9IiNGOURCNkQiLz4KPGNpcmNsZSBjeD0iMTE3LjUiIGN5PSI1NDYuNSIgcj0iMTUiIHRyYW5zZm9ybT0icm90YXRlKC0xODAgMTE3LjUgNTQ2LjUpIiBzdHJva2U9IiMzMzg4NzciIHN0cm9rZS1vcGFjaXR5PSIwLjA3IiBzdHJva2Utd2lkdGg9IjciLz4KPGNpcmNsZSBjeD0iNzA0LjUiIGN5PSI0OTEuNSIgcj0iMTUiIHRyYW5zZm9ybT0icm90YXRlKC0xODAgNzA0LjUgNDkxLjUpIiBzdHJva2U9IiMzMzg4NzciIHN0cm9rZS1vcGFjaXR5PSIwLjA3IiBzdHJva2Utd2lkdGg9IjciLz4KPGNpcmNsZSBjeD0iNjM2IiBjeT0iMTAzIiByPSIxOS41IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDYzNiAxMDMpIiBzdHJva2U9IiMzMzg4NzciIHN0cm9rZS1vcGFjaXR5PSIwLjA3IiBzdHJva2Utd2lkdGg9IjciLz4KPC9zdmc+Cg==";
export { SvgFutureBgSvg as ReactComponent };